import clsx from 'clsx'
import { useMemo } from 'react'

import type { DeliveryPartnersKeys } from '@/entities/order/types/delivery'

import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'
import { Select } from '@/shared/ui'
import { Autocomplete } from '@/shared/ui'

import { usePvz } from '../../hooks/use-pvz'
import { DrawerShopCard } from '../drawer-shop-card/drawer-shop-card'
import { ShopDetailCard } from '../shop-detail-card/shop-detail-card'
import { ShopsList } from '../shops-list/shops-list'
import { ShopsMap } from '../shops-map/shops-map'

import cls from './Pvz.module.scss'

interface DaliProps {
	className?: string
}

const selectAdapter = (items: Record<any, any> = []) => [
	{
		label: `Все службы выдачи`,
		value: null
	},
	...Object.entries(items).map(([value, label]) => ({
		label,
		value
	}))
]

export const Pvz = (props: DaliProps) => {
	const {
		activePoint,
		deliveryPointInfo,
		points,
		partners = [],
		isLoading,
		setActiveType,
		setActivePoint,
		removeActivePoint,
		cityName,
		cityList,
		selectCity,
		changeCityName,
		centerCoords
	} = usePvz()
	const adaptedCityList = useMemo(() => cityList.map(({ NAME }) => ({ label: NAME, value: NAME })), [cityList])
	const adaptedPartners = useMemo(() => selectAdapter(partners), [partners])
	const isMobile = useMemo(() => typeof window !== 'undefined' && window?.matchMedia('(max-width: 576px)').matches, [])
	const { className } = props

	return (
		<div className={clsx(className, cls.root)}>
			<div className={cls.filterPanel}>
				<Autocomplete
					className={cls.cityInput}
					onChange={evt => changeCityName(evt.target.value)}
					value={cityName}
					label="Город"
					disabled={isLoading}
					onSelectOption={value => selectCity(value)}
					options={adaptedCityList}
					onClear={() => changeCityName(null)}
					autoComplete="off"
					fullWidth
				/>
				<Select
					className={cls.select}
					options={adaptedPartners}
					defaultValue={adaptedPartners[0]}
					placeholder="Все службы ПВЗ"
					onChange={value => setActiveType(value as DeliveryPartnersKeys)}
					disabled={isLoading}
				/>
			</div>
			{isLoading && <SkeletonLoader className={cls.loader} height={475} width={685} borderRadius={8} />}
			<div className={cls.mapWrap}>
				{!isMobile && activePoint && (
					<ShopDetailCard
						point={activePoint}
						onClose={removeActivePoint}
						className={cls.shopsList}
						deliveryInfo={deliveryPointInfo}
					/>
				)}
				{!isMobile && !activePoint && (
					<ShopsList items={points} className={cls.shopsList} onSelect={point => setActivePoint(point)} />
				)}
				{!isLoading && (
					<ShopsMap
						// @ts-ignore
						centerCoords={centerCoords}
						points={points || []}
						activePoint={activePoint}
						onSelect={point => setActivePoint(point)}
					/>
				)}
				<DrawerShopCard
					open={isMobile && !!activePoint}
					point={activePoint}
					deliveryInfo={deliveryPointInfo}
					onClose={removeActivePoint}
				/>
			</div>
		</div>
	)
}
